module.exports = __webpack_public_path__ + "img/Frame15.b8ff81c1.png";